"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));
var _lockDefault = _interopRequireDefault(require("@teladoc/pulse/icons/lock-default.svg"));
var _environment = _interopRequireDefault(require("@livongo/utilities/system/environment"));
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _useLabelValidation = _interopRequireDefault(require("../Form/use-label-validation"));
var _TextAreaModule = _interopRequireDefault(require("./TextArea.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["classNameRoot", "classNameControl", "classNameItem", "classNameCounter", "testAttrRoot", "testAttrControl", "testAttrItem", "testAttrError", "i18nItemLabel", "id", "name", "label", "placeholder", "disabled", "required", "focus", "readOnly", "error", "customValidationError", "defaultValue", "value", "maxLength", "showCounter", "helpNode", "minRows", "maxRows", "onChange", "onFocus", "onBlur", "onInvalid"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const TextArea = _ref => {
  let {
      classNameRoot,
      classNameControl,
      classNameItem,
      classNameCounter,
      testAttrRoot,
      testAttrControl,
      testAttrItem,
      testAttrError,
      i18nItemLabel = '',
      id,
      name,
      label,
      placeholder,
      disabled,
      required,
      focus,
      readOnly,
      error,
      customValidationError,
      defaultValue,
      value,
      maxLength,
      showCounter,
      helpNode,
      minRows,
      maxRows,
      onChange,
      onFocus,
      onBlur,
      onInvalid
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    ref,
    errorId,
    isValid,
    errorElement,
    showInvalid,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    disabled,
    error,
    customValidationError,
    onInvalid
  });
  const [internalValue, setInternalValue] = (0, _react.useState)(value);
  const [length, setLength] = (0, _react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) || 0);
  const [charsLeftUI, setCharsLeftUI] = (0, _react.useState)(maxLength);
  const [charsLeftAnnounce, setCharsLeftAnnounce] = (0, _react.useState)(maxLength);
  const isWindows = _environment.default.isWindows();
  const onChangeCallback = evt => {
    setInternalValue(evt.target.value);
    setValidationState(null);
    if (showCounter) {
      setLength(evt.target.value.length);
    }
    if (onChange) {
      onChange(evt);
    }
  };
  (0, _useLabelValidation.default)(label, i18nItemLabel, rest);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    if (showCounter && !maxLength) {
      throw new Error('You must provide a maxLength to use with the counter.');
    }
  });
  (0, _react.useEffect)(() => {
    if (focus) {
      const {
        current: field
      } = ref;
      const fieldLength = field.value.length;
      field.focus();
      field.setSelectionRange(fieldLength, fieldLength);
    }
  }, [focus, ref]);
  (0, _react.useEffect)(() => {
    setValidationState(null);
  }, [disabled, setValidationState]);
  (0, _react.useEffect)(() => {
    if (maxLength) {
      setCharsLeftUI(maxLength - length);

      // should use this delay for fixing screenreader's double announcement
      const timer = setTimeout(() => {
        setCharsLeftAnnounce(maxLength - length);
      }, 1600);
      return () => clearTimeout(timer);
    }
  }, [maxLength, length]);
  (0, _react.useEffect)(() => {
    setInternalValue(value);
  }, [value]);
  const isTextareaEmpty = chars => chars === maxLength;
  const charsMaximum = () => "".concat(t('ui:textArea.chars.upTo'), " ").concat(maxLength, " ").concat(t('ui:textArea.chars.characters'));
  const charsRemaining = remaining => "".concat(remaining, " ").concat(t('ui:textArea.chars.remaining'));
  const isTextareaEmptyAnnounce = maxLength && isTextareaEmpty(charsLeftAnnounce);
  const charsRemainingUI = maxLength && charsRemaining(charsLeftUI);
  const charsRemainingAnnounce = maxLength && charsRemaining(charsLeftAnnounce);
  const charsMaximumAnnounce = maxLength && !length ? charsMaximum() : '';
  const describedBy = [];
  if (helpNode) {
    describedBy.push("".concat(id, "-help"));
  }
  if (charsMaximumAnnounce) {
    describedBy.push("".concat(id, "-chars-maximum"));
  }
  if (showInvalid) {
    describedBy.push(errorId);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_TextAreaModule.default.root, {
      [_TextAreaModule.default.containsError]: !isValid
    }, {
      [_TextAreaModule.default.withHelpNode]: Boolean(helpNode)
    }, {
      [_TextAreaModule.default.withCounter]: showCounter
    }, {
      [_TextAreaModule.default.readOnly]: readOnly
    }, {
      [_TextAreaModule.default.disabled]: disabled
    }, classNameRoot)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    "data-testid": testAttrRoot,
    children: [label && /*#__PURE__*/(0, _react.cloneElement)(label, {
      className: (0, _cnbuilder.cnb)(_TextAreaModule.default.label, label.props.className),
      htmlFor: id,
      id: "".concat(id, "-label"),
      required
    }), helpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _TextAreaModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), charsMaximumAnnounce && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)('visually-hidden'),
      id: "".concat(id, "-chars-maximum"),
      "aria-hidden": true,
      children: charsMaximumAnnounce
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cnbuilder.cnb)(_TextAreaModule.default.control, classNameControl),
      "data-testid": testAttrControl,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTextareaAutosize.default, _objectSpread(_objectSpread(_objectSpread({
        ref: ref,
        id: id,
        "data-testid": testAttrItem,
        className: (0, _cnbuilder.cnb)(_TextAreaModule.default.item, classNameItem),
        name: name,
        placeholder: placeholder,
        required: required,
        disabled: disabled,
        "aria-label": i18nItemLabel,
        maxLength: maxLength,
        defaultValue: defaultValue,
        value: internalValue,
        readOnly: readOnly,
        minRows: minRows,
        maxRows: maxRows
      }, describedBy.length && {
        'aria-describedby': describedBy.join(' ')
      }), !isWindows && {
        'aria-errormessage': "".concat(errorId)
      }), {}, {
        "aria-invalid": !isValid,
        onChange: onChangeCallback,
        onFocus: onFocus,
        onBlur: onBlur
      })), readOnly && !disabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _TextAreaModule.default.lock,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lockDefault.default, {})
      }) : showCounter && ((0, _isFunction.default)(showCounter) ? showCounter(length, maxLength) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _cnbuilder.cnb)(_TextAreaModule.default.counter, classNameCounter),
        "aria-hidden": true,
        children: isTextareaEmpty(charsLeftUI) ? charsMaximum() : charsRemainingUI
      }))]
    }), showCounter && Boolean(showCounter) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)('visually-hidden'),
      role: isTextareaEmptyAnnounce ? null : 'status',
      "aria-live": isTextareaEmptyAnnounce ? null : 'polite',
      children: isTextareaEmptyAnnounce ? charsMaximum() : charsRemainingAnnounce
    }), showInvalid && /*#__PURE__*/(0, _react.cloneElement)(errorElement, {
      id: errorId,
      testAttr: testAttrError
    })]
  }));
};
TextArea.defaultProps = {
  testAttrRoot: 'text-area-root',
  testAttrControl: 'text-area-control',
  testAttrItem: 'text-area-item',
  testAttrError: 'text-area-error',
  minRows: 3
};
var _default = exports.default = TextArea;